export const PROD_BASE_URL = "https://uconline.edu";
export const QA_BASE_URL = "https://qa.uconline.edu";

export const SF_TERM_FIELD_ID = "00NF000000CsuqK";
export const SF_COURSE_FIELD_ID = "00NF000000DClB0";